/**
 * Formats a price for display.
 * @param cents - Price in cents (e.g. 1099 → "$10.99")
 * @param locale - BCP 47 locale string (e.g. "en-US")
 * @param currency - ISO 4217 currency code (e.g. "USD")
 */
export function formatPrice(cents: number, locale: string, currency: string): string {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
	}).format(cents / 100)
}
